// Small purple flame used to mark pyro-capable drones across the app.
// Sourced from the dashboard CapacityCard (Pyro variant) so all surfaces match.

import React from 'react';

interface FlameIconProps {
  className?: string;
  /** Hide the twinkling sparks (set false for static contexts like printable lists). */
  animated?: boolean;
  title?: string;
}

const FlameIcon: React.FC<FlameIconProps> = ({
  className = 'w-4 h-4',
  animated = true,
  title,
}) => (
  <svg className={className} viewBox="0 0 20 20" fill="none" aria-label={title} role={title ? 'img' : undefined}>
    {title && <title>{title}</title>}
    <path d="M10 1C10 1 4 8 4 12.5C4 16 6.5 18 10 18C13.5 18 16 16 16 12.5C16 8 10 1 10 1Z" fill="#a855f7" />
    <path d="M10 8C10 8 7 11.5 7 13.5C7 15.2 8.3 16.5 10 16.5C11.7 16.5 13 15.2 13 13.5C13 11.5 10 8 10 8Z" fill="#c084fc" />
    <path d="M10 12C10 12 9 13.2 9 14C9 14.6 9.4 15 10 15C10.6 15 11 14.6 11 14C11 13.2 10 12 10 12Z" fill="#e9d5ff" />
    {animated && (
      <>
        <circle cx="5" cy="4" r="0.6" fill="#e9d5ff">
          <animate attributeName="opacity" values="0;1;0" dur="1.2s" repeatCount="indefinite" />
        </circle>
        <circle cx="15" cy="5" r="0.5" fill="#e9d5ff">
          <animate attributeName="opacity" values="0;1;0" dur="0.9s" repeatCount="indefinite" begin="0.3s" />
        </circle>
      </>
    )}
  </svg>
);

export default FlameIcon;
